import { IApplicationState } from '../../types/redux';
import { IFormState } from '../../types/form';

export function selectForm(state: IApplicationState): IFormState {
  return state.form;
}

export function selectFileUploadingProgress(state: IApplicationState): number {
  return state.form.fileUploadingProgress;
}
